/* Runtime selection of the analytics data source.
 *
 * If VITE_ANALYTICS_API_BASE is set (via .env or window.deploymentEnvVars), the
 * dashboard talks to the real gateway API through HttpAnalyticsClient; otherwise
 * it falls back to the deterministic MockAnalyticsClient. This is the single
 * switch the CLAUDE.md refers to. Read from window.__env__ (populated by env.ts
 * from VITE_* vars) so it works the same in dev, build, and tests. */

export function readEnv(key: string): string | undefined {
  if (typeof window === "undefined") return undefined;

  const value = window.__env__?.[key];
  return value && value.length > 0 ? value : undefined;
}

/** Gateway mount root the dashboard talks to, e.g. "/coding-gateway/internal"
 *  (sidecar) or "https://api.ai21.com/tokenwise" (studio). The clients append
 *  their own sub-path under it — analytics adds "/analytics/v1", the admin CRUD
 *  adds "/settings/configs" | "/settings/agents". Undefined ⇒ use the mock. */
export const API_BASE = readEnv("VITE_ANALYTICS_API_BASE");

/** Optional bearer token. Local dev is open; networked/prod deployments set
 *  ANALYTICS_API_KEY and require it on every request (UI_CHANGELOG #7). */
export const API_KEY = readEnv("VITE_ANALYTICS_API_KEY");

/** True when a real API base is configured. */
export const USE_REAL_API = API_BASE !== undefined;
